/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";
import moment from 'moment';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

export default function Terminal(props) {
  const token = localStorage.token;
  const role = localStorage.getItem("authority");
  const merchantPk = props.merchantPk;
  const merchantName = props.merchantName;
  const [allTerminal, setAllTerminal] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [rowIndex, setRowIndex] = useState(0);
  const projectId = parseInt(localStorage.getItem("projectId"));
  const allowedRoles = ["ROLE_SUPERADMIN"];
  const allowedProject = ["ROLE_OPERATOR_PROJECT", "ROLE_SUPERVISOR_PROJECT", "ROLE_ADMIN_PROJECT"];
  const allowedGroup = ["ROLE_OPERATOR_GROUP", "ROLE_SUPERVISOR_GROUP", "ROLE_ADMIN_GROUP"];
  const allowedMerchant = ["ROLE_OPERATOR_MERCHANT", "ROLE_SUPERVISOR_MERCHANT", "ROLE_ADMIN_MERCHANT"];

  let paginationOption = {
    page: 1,
    alwaysShowAllBtns: true,
    override: true,
    showTotal: true,
    withFirstAndLast: false,
    onPageChange: (page) => {
      calculateRowIndex(page, currentPageSize);
    },
    sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
      <div className="dataTables_length" id="datatable-basic_length">
        <label>
          Show{" "}
          {
            <select
              name="datatable-basic_length"
              aria-controls="datatable-basic"
              className="form-control form-control-sm"
              onChange={(e) => {
                onSizePerPageChange(e.target.value);
                setCurrentPageSize(e.target.value);
                calculateRowIndex(currentPage, e.target.value);
              }}
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          }{" "}
          entries.
        </label>
      </div>
    ),
  }

  const calculateRowIndex = (currentPage, currentPageSize) => {
    setRowIndex((currentPage - 1) * currentPageSize);
  }

  useEffect(() => {
    getAllTerminal();
  }, [props.merchantPk]);

  const getAllTerminal = () => {
    if (allowedRoles.includes(localStorage.getItem("authority"))) {
      const data = { page: 1, per_page: 100, role: role, merchantPk: 0, merchant_pk: parseInt(merchantPk) }
      fetch(`${process.env.REACT_APP_API_BASE_URL}/terminals`, {
        method: 'POST', // or 'PUT'
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(response => response.json())
        .then(data => {
          setAllTerminal(data.response_data);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
    if (allowedProject.includes(localStorage.getItem("authority"))) {
      const data = { page: 1, per_page: 100, role: role, projectId: parseInt(merchantPk), merchantPk: parseInt(merchantPk) }
      fetch(`${process.env.REACT_APP_API_BASE_URL}/terminals`, {
        method: 'POST', // or 'PUT'
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(response => response.json())
        .then(data => {
          setAllTerminal(data.response_data);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
    if (allowedGroup.includes(localStorage.getItem("authority"))) {
      const data = { page: 1, per_page: 100, role: role, projectId: parseInt(projectId), groupId: parseInt(merchantPk), merchantPk: parseInt(merchantPk) }
      fetch(`${process.env.REACT_APP_API_BASE_URL}/terminals`, {
        method: 'POST', // or 'PUT'
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(response => response.json())
        .then(data => {
          setAllTerminal(data.response_data);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
    if (allowedMerchant.includes(localStorage.getItem("authority"))) {
      const data = { page: 1, per_page: 100, role: role, merchantPk: parseInt(merchantPk) }
      fetch(`${process.env.REACT_APP_API_BASE_URL}/terminals`, {
        method: 'POST', // or 'PUT'
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(response => response.json())
        .then(data => {
          setAllTerminal(data.response_data);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }

  return (
    <>
      <Card>
        <CardHeader>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3>Terminal ({merchantName})</h3>
          </div>
        </CardHeader>
        <CardBody>
          <ToolkitProvider
            rowNumber={rowIndex}
            data={allTerminal}
            keyField="terminal_pk"
            columns={[
              {
                dataField: "no",
                text: "#",
                sort: true,
                page: 1,
                formatter: (cell, row, index) => {
                  let currentRow = ++index;
                  return currentRow + rowIndex;
                }
              },
              {
                dataField: "serial_number",
                text: "Serial Number",
                sort: true,
              },
              {
                dataField: "terminal_code",
                text: "Terminal Code",
                sort: true,
              },
              {
                dataField: "terminal_type",
                text: "Tipe",
                sort: true,
              },
              {
                dataField: "merchant_name",
                text: "Nama Merchant",
                sort: true,
              },
              {
                dataField: "reference_no",
                text: "Ref No",
                sort: true,
              },
              {
                dataField: "installation_date",
                text: "Tanggal Pasang",
                sort: true,
                formatter: (cell, row, index) => {
                  return row.installation_date ? moment(row.installation_date, "DD/MM/YYYY").format("DD/MM/yyyy") : '(Not set)'
                }
              },
              {
                dataField: "statusTerminal",
                text: "Status",
                sort: true,
                formatter: (cell, row, index) => {
                  return row.statusTerminal === 1 ? "Active" : "InActive"
                }
              },
            ]}
          >
            {(props) => (
              <div className="py-4 table-responsive">
                <BootstrapTable
                  {...props.baseProps}
                  bootstrap4={true}
                  bordered={false}
                  hover={true}
                  pagination={paginationFactory({ ...paginationOption })}
                />
              </div>
            )}
          </ToolkitProvider>
        </CardBody>
      </Card>
    </>
  );
}
